/**
 * Binary-file row normalization for the media feature.
 *
 * The media grids and galleries render rows from two paths — a direct grid
 * fetch and the Redux store (ImageGallery). Both must carry the same shape, so
 * every binary-file row is mapped through here: `id` aliases the guid (the grid
 * + delete/edit path key by it), `image` aliases file_url (for <img>/Download),
 * and `camera` aliases actor.id (the camera PK on a cic-image row, used to group
 * captures by camera in the gallery). `camera_number`/`camera_description` are
 * served directly by the binary-files descriptor and pass through untouched.
 */

/**
 * @param {object} row - a raw /api/odl-app/binary-files/ row
 * @returns {object} the row with id/image/camera aliases added
 */
export function normalizeBinaryFileRow(row) {
  return {
    ...row,
    id: row.guid,
    image: row.file_url,
    camera: row.actor?.id,
  };
}
